export default __webpack_public_path__ + "static/media/v-10.6b0a3ae2.svg";